var INFO_TYPE = {
    NO_BACKGROUND: 'NO_BACKGROUND',
    ATTACHED_BACKGROUND: 'ATTACHED_BACKGROUND',
    SEPARATED_BACKGROUND: 'SEPARATED_BACKGROUND',
    DONT_SHOW: 'DONT_SHOW',
};
export default INFO_TYPE;
//# sourceMappingURL=infoType.js.map